<template>
  <div class="voyage-dialog">
    <el-dialog title="检查航次" :visible.sync="visible" :before-close="closeDialog" :width="checkShipPlanData.status == 3 ? '360px' : '1040px'" :close-on-click-modal="false">
      <div v-if="checkShipPlanData.status == 1">
        <div class="mb-24">
          <WTable :WTableOpts="WTableOpts1" />
        </div>
        <div>
          <WTable :WTableOpts="WTableOpts2">
            <template #eta="{ row }">
              <span>{{ row.eta ? moment(row.eta).format('YYYY-MM-DD HH:mm:ss') : '/'}}</span>
            </template>
            <template #etd="{ row }">
              <span>{{ row.etd ? moment(row.etd).format('YYYY-MM-DD HH:mm:ss') : '/'}}</span>
            </template>
          </WTable>
        </div>
      </div>
      <!-- gmtModified: [moment(nowDate.getTime() - 3600 * 1000 * 24 * 31 + 1000).format('YYYY-MM-DD HH:mm:ss'), moment(nowDate.getTime()).format('YYYY-MM-DD HH:mm:ss')] -->

      <div v-if="checkShipPlanData.status == 2">
        <div style="margin-bottom: 18px;">
          <div>未在港区找到该船名航次，填写可能有误，请核实！</div>
          <div>目前港区航次如下：</div>
        </div>
        <div>
          <WTable :WTableOpts="WTableOpts">
            <template #eta="{ row }">
              <span>{{ row.eta ? moment(row.eta).format('YYYY-MM-DD HH:mm:ss') : '/'}}</span>
            </template>
            <template #etd="{ row }">
              <span>{{ row.etd ? moment(row.etd).format('YYYY-MM-DD HH:mm:ss') : '/'}}</span>
            </template>
          </WTable>
        </div>
      </div>
      <div v-if="checkShipPlanData.status == 3">
        <!-- <div style="margin-bottom: 18px;"> -->
        <div>未在港区找到该船名航次，填写可能有误，请核实！</div>
        <!-- </div> -->
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: "Voyage",
  props: {
    visible: Boolean,
    checkShipPlanData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      moment,
      WTableOpts: {
        data: [],
        tableAttrs: { border: false },
        tableColAttrs: [
          { prop: 'terminalCode', label: '停靠码头'},
          { prop: 'shipName', label: '船名'},
          { prop: 'voyOut', label: '航次'},
          { prop: '', slotName:'eta', label: '计划靠泊时间'},
          { prop: '', slotName:'etd', label: '计划离泊时间'},
        ]
      },
      WTableOpts1: {
        data: [],
        tableAttrs: { border: false },
        tableColAttrs: [
          { prop: 'shipName', label: '船名'},
          { prop: 'voyOut', label: '航次'},
          { prop: 'terminalCode', label: '码头'},
          // { prop: '', label: '港口代码'},
          // { prop: '', label: '港口中文名'},
          // { prop: '', label: '港口英文名'},
        ]
      },
      WTableOpts2: {
        data: [],
        tableAttrs: { border: false },
        tableColAttrs: [
          // { prop: 'agent', label: '预计抵锚时间'},
          { prop: '', slotName:'eta', label: '计划靠泊时间'},
          { prop: '', slotName:'etd', label: '计划离泊时间'},
        ]
      },
    }
  },
  created() {
    this.WTableOpts.data = this.checkShipPlanData.shipPlanList
    this.WTableOpts1.data = this.checkShipPlanData.shipPlanList
    this.WTableOpts2.data = this.checkShipPlanData.shipPlanList
  },
  methods: {
    // 联系客服
    toQQ(){
      window.open('https://wpa1.qq.com/yGWcFLfo?_type=wpa&qidian=true')
    },
    // 关闭
    closeDialog(){
      this.$emit('closeDialog')
    }
  }
}
</script>

<style scoped lang="less">
.voyage-dialog {
  color: #333333;
  font-size: 14px;

  .el-button {
    height: 32px;
  }
}
</style>